import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import GoogleMap from "../components/map/map"
import Img from "gatsby-image"
import { animated, useSpring } from "react-spring"

import "./contact.sass"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const FACEBOOK = "https://www.facebook.com/ConcordPacificDevInc/"
const INS = "https://www.instagram.com/concordpacific/"
const YOUTUBE = "https://www.youtube.com/user/ConcordPacificDevInc"

const Contact = () => {
  const fade = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
  })
  const data = useStaticQuery(graphql`
    query {
      qr: file(relativePath: { eq: "icons/qr.png" }) {
        childImageSharp {
          fixed(width: 192) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <Layout>
      <SEO title="Contact" />
      <animated.div style={fade} id="contact">
        <h1 className="page-title">Contact Us</h1>
        <div className="grid">
          <div className="row">
            <div className="col map">
              <GoogleMap />
            </div>
          </div>
          <div className="row info">
            <div className="pc-info">
              <h1 className="title">sales center</h1>
              <span>700 1st Ave SW</span>
              <span>Calgary, AB</span>
              <span>Canada</span>
              <span>
                <a href="tel:(403)266-0038">Tel: (403) 266-0038</a>
              </span>
              <a
                href="https://www.google.com/maps/place/700+1+Ave+SW,+Calgary,+AB+T2P+5G8/@51.0525631,-114.078522,17z/data=!3m1!4b1!4m5!3m4!1s0x53716feffe39b11f:0xa28cc9dc5ebdce92!8m2!3d51.0525631!4d-114.076328"
                target="_blank"
                className="hyperlink"
                rel="noopener noreferrer"
              >
                get directions
              </a>
            </div>
            <div className="hours">
              <h1 className="title">hours</h1>
              <span>By Appointment Only</span>
              <a
                href="https://www.concordpacific.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="hyperlink"
              >
                other presentation centres
              </a>
            </div>
            <div className="follow">
              <h1 className="title">follow us</h1>
              <div className="social-icons">
                <a href={FACEBOOK} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "facebook-square"]} />
                </a>
                <a href={INS} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "instagram"]} />
                </a>
                <a href={YOUTUBE} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "youtube"]} />
                </a>
                <a
                  href="http://www.weibo.com/u/3053263165?refer_flag=1005055013_"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={["fab", "weibo"]} />
                </a>
              </div>
              <div className="qr">
                <Img fixed={data.qr.childImageSharp.fixed} />
              </div>
              <span>
                <FontAwesomeIcon icon={["fab", "weixin"]} className="wechat" />
                ConcordCanada
              </span>
            </div>
          </div>
        </div>
      </animated.div>
    </Layout>
  )
}

export default Contact
